import Text from '../../atoms/Text';
import Colors from '../../tokens/Colors';

const Cartola = ({ color, value, size }) => {
    return (
        <Text size={size ?? '12 16'} highlight upper color={color ? color : Colors.darkGrey}>
            {value || 'Notícia'}
        </Text>
    );
};

export default Cartola;
